import { IPartialCSS } from "partnerbuilder-common";
import {
    BackgroundStyles,
    BorderRadiusStyles,
    FontStyles,
    PaddingStyles,
    BorderStyles,
    OpacityStyles,
    HeightStyles,
    WidthStyles,
    MarginStyles,
    AlignStyles,
    ColorStyles,
    BoxShadowSyles,
    TextShadowSyles
} from "./GroupsStyles.static";

export const LinkStyles: IPartialCSS<any> = {
    ...BackgroundStyles,
    ...PaddingStyles,
    ...AlignStyles,
    ...FontStyles,
    ...ColorStyles,
    ...BorderRadiusStyles,
    ...BorderStyles,
    ...OpacityStyles,
    ...BoxShadowSyles,
    ...TextShadowSyles,
    ...HeightStyles,
    ...WidthStyles,
    ...MarginStyles
};
